import Enum from '@/modules/core/app/models/abstracts/Enum';

export const DISABLE = 'disable';

export const RoleReportingProfilePermission = {
  ONLY_ASSIGNED: 'only_assigned',
  ALL: 'all',
  SELECTION: 'selection',
};

export const RoleRoute = {
  ROLES: 'roles',
};

export const RolePathName = {
  ROLES: 'roles',
  ROLEFORM_NEW: 'roleform:new',
  ROLEFORM: 'roleform',
  ROLEFORM_TAB: 'roleform.tabname',
};

export const RoleFormTab = {
  GENERAL: 'general',
  ASSIGNED_USERS: 'assigned_users',
};

export const RoleTitles = ['Users', 'Roles'];

export const RoleUsageNames = ['user', 'role'];

export const RolePermissionValue = {
  NONE: 'none',
  READ_ONLY: 'read_only',
  ALL: 'all',
};

export const RestrictUserTypeRolePermissionValue = {
  NONE: 'none',
  BELOW: 'below',
  AT_AND_BELOW: 'at_and_below',
};

export const RolePermissionType = {
  ACCESS_OPTIONS: 'access_options',
  BOOLEAN: 'boolean',
};

export const RolePermissionGroup = {
  DATA_CONFIGURATION: 'data_configuration',
  AUTO_MAPPING: 'auto_mapping',
  DATA_TRANSFORMATION: 'data_transformation',
  DATA_EXPORT: 'data_export',
  DASHBOARDS: 'dashboards',
  REPORT_STUDIO: 'report_studio',
  REPORTING: 'reporting',
  PERFORMANCE_TRACKING: 'performance_tracking',
  LEADS_MANAGEMENT: 'leads_management',
  AUDIENCE: 'audience',
  ACCOUNTS: 'accounts',
  ORGANIZATION: 'organization',
  PLATFORM_ADMINISTRATION: 'platform_administration',
  PROPOSAL: 'proposal',
  ORDER_MANAGEMENT: 'order_management',
  WORKFLOW_MANAGEMENT: 'workflow_management',
  AI_AGENT: 'ai_agent',
  PUSHCONNECTOR: 'pushconnector',
  SALES: 'sales',
};

export function GetRolePermissionGroupTitleMapping() {
  return {
    data_configuration: i18n.$t('Data Connection & Configuration'),
    auto_mapping: i18n.$t('Auto Assignment Rules'),
    data_transformation: i18n.$t('Data Transformation'),
    data_export: i18n.$t('Data Export'),
    dashboards: i18n.$t('Dashboards'),
    report_studio: i18n.$t('Report Studio'),
    reporting: i18n.$t('Reporting'),
    performance_tracking: i18n.$t('Performance Tracking'),
    leads_management: i18n.$t('Leads Management'),
    audience: i18n.$t('Audience'),
    accounts: i18n.$t('Your Business'),
    organization: i18n.$t('Access'),
    platform_administration: i18n.$t('Platform Management'),
    ai_agent: i18n.$t('AI Agents'),
    proposal: i18n.$t('Proposal'),
    order_management: i18n.$t('Order Management'),
    workflow_management: i18n.$t('Workflow Management'),
    pushconnector: i18n.$t('Push to Server'),
    sales: i18n.$t('Sales'),
  };
}

export const RolePermissionKey = {
  CAN_READ_WRITE: 'can_read_write',
  CAN_ACCESS_ACORN: 'can_access_acorn',
  CAN_ACCESS_RIPLEY: 'can_access_ripley',
  CAN_ACCESS_ZEST: 'can_access_zest',
  CAN_ACCESS_SHEETS: 'can_access_sheets',
  CAN_ACCESS_GDS: 'can_access_gds',
  CAN_ACCESS_TECH_SUPPORT_CHATBOT: 'can_access_tech_support_chatbot',
  CAN_IMPERSONATE_OTHER_AGENTS: 'can_impersonate_other_agents',
  CAN_CLUSTER_ADMINS_CONNECT_SERVICES: 'can_cluster_admins_connect_services',
  CAN_PUBLISH_TO_LIBRARY: 'can_publish_to_library',
  CAN_EDIT_REPORTING_OPTIONS: 'can_edit_reporting_options',
  CAN_EDIT_DRAW_OPTIONS: 'can_edit_draw_options',
  CAN_READ_WRITE_MANUAL_UPLOAD: 'can_read_write_manual_upload',
  CAN_EDIT_WIDGET_ALERTS: 'can_edit_widget_alerts',
  CAN_EDIT_WIDGET_ANNOTATIONS: 'can_edit_widget_annotations',
  CAN_ACCESS_ROLES: 'can_access_roles',
  CAN_READ_WRITE_FILTER_SET: 'can_read_write_filter_set',
  CAN_READ_WRITE_CATALOGUE_SETTINGS: 'can_read_write_catalogue_settings',
  CAN_READ_WRITE_ORDER_CREATION: 'can_read_write_order_creation',
  CAN_READ_WRITE_ORDER_UPDATE: 'can_read_write_order_update',
  CAN_READ_WRITE_ORDER_CANCEL: 'can_read_write_order_cancel',
  CAN_READ_WRITE_ORDER_QUICK_VIEW: 'can_read_write_order_quick_view',
  CAN_READ_WRITE_ORDER_STATUS: 'can_read_write_order_status',
  CAN_READ_WRITE_FORM_GROUPS: 'can_read_write_form_groups',
  CAN_READ_WRITE_LINE_ITEM_CREATION: 'can_read_write_line_item_creation',
  CAN_READ_WRITE_ORDER_DETAIL_LINE_ITEM_LIST: 'can_read_write_order_detail_line_item_list',
  CAN_READ_WRITE_LINE_ITEM_UPDATE: 'can_read_write_line_item_update',
  CAN_READ_WRITE_LINE_ITEM_CANCEL: 'can_read_write_line_item_cancel',
  CAN_READ_WRITE_LINE_ITEM_QUICK_VIEW: 'can_read_write_line_item_quick_view',
  CAN_READ_WRITE_LINE_ITEM_STATUS: 'can_read_write_line_item_status',
  CAN_READ_WRITE_CREATIVE_TAG: 'can_read_write_creative_tag',
  CAN_READ_WRITE_FLIGHT_CREATION: 'can_read_write_flight_creation',
  CAN_READ_WRITE_FLIGHT_UPDATE: 'can_read_write_flight_update',
  CAN_READ_WRITE_FLIGHT_CANCEL: 'can_read_write_flight_cancel',
  CAN_READ_WRITE_FLIGHT_QUICK_VIEW: 'can_read_write_flight_quick_view',
  CAN_READ_WRITE_FLIGHT_STATUS: 'can_read_write_flight_status',
  CAN_READ_WRITE_LINE_ITEM_LEVEL_FLIGHT_LISTS: 'can_read_write_line_item_level_flight_lists',
  MANAGE_ACCESS_LISTS: 'manage_access_lists',
  LIMIT_DASHBOARD_ACCESS_WITH_DATA_PROFILE: 'limit_dashboard_access_with_data_profile',
  LIMIT_REPORT_STUDIO_ACCESS_WITH_DATA_PROFILE: 'limit_report_studio_access_with_data_profile',
  CAN_READ_WRITE_PROPOSAL_CREATION: 'can_read_write_proposal_creation',
  CAN_APPROVE_REJECT_PROPOSAL: 'can_approve_reject_proposal',
  CAN_PROPOSAL_AI_RECOMMENDATION: 'can_proposal_ai_recommendation',
  CAN_CLIENT_ANALYSIS: 'can_client_analysis',
  CAN_GOOGLE_ADS: 'can_google_ads',
  CAN_LINKEDIN_ADS: 'can_linkedin_ads',
  CAN_FACEBOOK_ADS: 'can_facebook_ads',
  CAN_DATAFUSION: 'can_datafusion',
  ENABLE_ORDER_MANAGEMENT: 'enable_order_management',
  ENABLE_ADFLO_PROPOSAL: 'enable_adflo_proposal',
};

export class PredefinedRoleKey extends Enum {
  static DEFAULT_ROLE = 'default_role';

  static SALES = 'sales';

  static SALES_SUPPORT = 'sales_support';

  static AD_OPERATIONS = 'ad_operations';

  static SALES_MANAGER = 'sales_manager';

  static AD_OPERATIONS_MANAGER = 'ad_operations_manager';

  static VENDOR = 'vendor';

  static SUPERADMIN = 'superadmin';

  static VENDOR_RESTRICTED = 'vendor_restricted';

  static PARTNER = 'partner';

  static CLIENT = 'client';

  static FINANCE = 'finance';

  static VIEWER = 'viewer';

  static SALES_VIEWER = 'sales_viewer';

  static SUPER_ADMIN_ROLE = 'super_admin_role';

  static CLUSTER_ADMIN_ROLE = 'cluster_admin_role';

  static AGENT_ROLE = 'agent_role';

  static CLIENT_ROLE = 'client_role';

  static CLUSTER_ADMIN_WITH_MAPPINGS_ACCESS_ROLE = 'cluster_admin_with_mappings_access_role';

  /**
   *
   * @returns {Array<String>}
   */
  static getPredefinedUserTypeRoles() {
    return [
      PredefinedRoleKey.SUPER_ADMIN_ROLE,
      PredefinedRoleKey.CLUSTER_ADMIN_ROLE,
      PredefinedRoleKey.AGENT_ROLE,
      PredefinedRoleKey.CLIENT_ROLE,
      PredefinedRoleKey.CLUSTER_ADMIN_WITH_MAPPINGS_ACCESS_ROLE,
    ];
  }
}

export const DefaultRole = {
  ID: '1',
  PREDEFINED_ROLE_KEY: PredefinedRoleKey.DEFAULT_ROLE,
};

export const PredefinedRoleValues = {
  SUPER_ADMIN_ROLE: 'Super Admin Role',
  CLUSTER_ADMIN_ROLE: 'Business Unit Admin Role',
  AGENT_ROLE: 'Agent Role',
  CLIENT_ROLE: 'Client Role',
  CLUSTER_ADMIN_WITH_MAPPINGS_ACCESS_ROLE: 'Business Unit Admin With Assignments Access Role',
};

export const RoleNames = {
  SUPER_ADMIN: 'SuperAdmin',
  CLIENT: 'Client',
};

export const RoleEvents = {
  INPUT: 'input',
};

export const ModuleGroupPermissionValue = {
  NONE: 'none',
  READ_ONLY: 'read_only',
  CREATE: 'create',
  UPDATE: 'update',
  ALL: 'all',
};

export const GroupSelectConstants = {
  PRIMARY_KEY: 'id',
  VALUE_KEY: 'name',
  SORT_BY_CREATED_DESC: '-created_at',
  LINE_ITEM: 'line_item',
};

export const QUEUE_RESTRICTIONS = 'queue_restrictions';
